module.exports = {
	"generation": 12,
	"links_in_ad": 3,
	"items": [
		{
			"id": 12317,
			"name": "Express Basic After Effects Customization",
			"url": "https://studio.envato.com/explore/after-effects-customization/12317-express-basic-after-effects-customization",
			"price_from": 150
		},
		{
			"id": 11537,
			"name": "Professional Corporate Stationery Design",
			"url": "https://studio.envato.com/explore/stationery-design/11537-corporate-professional-stationery-design",
			"price_from": 70
		},
		{
			"id": 2616,
			"name": "Professional and Fun Infographics",
			"url": "https://studio.envato.com/explore/infographic-design/2616-professional-and-fun-infographics",
			"price_from": 300
		},
		{
			"id": 44936,
			"name": "Logo Sound Design",
			"url": "https://studio.envato.com/explore/jingles-drops/44936-logo-sound-design-10-seconds",
			"price_from": 50
		},
		{
			"id": 13313,
			"name": "Explainer, Sales, Startup, Promotional Videos",
			"url": "https://studio.envato.com/explore/explainer-videos/13313-explainer-video-sales-video-startup-video-promotional-videos",
			"price_from": 950
		},
		{
			"id": 17340,
			"name": "Redesign Mobile or Browser Game",
			"url": "https://studio.envato.com/explore/mobile-design-development/17340-game-development-design-reskin",
			"price_from": 150
		},
		{
			"id": 9314,
			"name": "1 Minute Explainer Animation plus Voice Over and Music",
			"url": "https://studio.envato.com/explore/explainer-videos/9314-explainer-animation-1-minute-voice-over-and-music",
			"price_from": 1500
		},
		{
			"id": 3336,
			"name": "Fun Professional Avatar",
			"url": "https://studio.envato.com/explore/social-media-design/3336-fun-professional-avatar",
			"price_from": 50
		},
		{
			"id": 44863,
			"name": "Original Music Composition",
			"url": "https://studio.envato.com/explore/music-production/44863-original-music-composition",
			"price_from": 300
		},
		{
			"id": 10073,
			"name": "Professional Web Banner Design",
			"url": "https://studio.envato.com/explore/web-banner-design/10073-professional-web-banner-design",
			"price_from": 50
		},
		{
			"id": 17634,
			"name": "Professional Unique Logo Intro Opener",
			"url": "https://studio.envato.com/explore/logo-animation/17634-professional-unique-logo-intro-opener",
			"price_from": 100
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./config/sites/studio-recommendations/videohive.json
// module id = 238
// module chunks = 1 2